/**
 * @file エントリーポイント：症例詳細ページ
 */

// ライブラリ読み込み
import React from "react";
import { createRoot } from "react-dom/client";

// コンポーネント読み込み
import { VideoVideo } from "~/src/components/pages/Video/Video";

// エントリーポイントにReactDOMをレンダリング
const entrypoint = document.getElementById("js-entrypoint-video-video");
const root = createRoot(entrypoint);
root.render(<VideoVideo />);
